<template>
    <div class="EvaluationThird" id="EvaluationThird" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.7)" element-loading-text="文件正在下载，请稍等" element-loading-spinner="el-icon-loading">
      <div class="evaluateMain">
        <div class="table_panel">
            <span style="font-size:14px;;font-weight:600">危险房屋鉴定标准指标</span>
        </div>
        <div class="table">
            <el-table
                :header-cell-style="{background:'#335ABB',color:'#FFF'}"
                stripe
                :data="tableData"
                style="width: 100%;font-size:14px;">
                <el-table-column
                    prop="standard"
                    label="评价标准"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="definition"
                    label="定义"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="accord"
                    align="center"
                    label="参考规范">
                </el-table-column>
            </el-table>
<!--            <div class="table_panel">-->
<!--                <span style="margin-right:25%;color:#E68F02;" @click="downloadLeft()">煤炭工业露天矿边坡工程监测规范（GB 51214-2017）</span>-->
<!--                <span style="color:#E68F02;"  @click="downloadRight()">滑坡防治工程勘查规范（DZT0218-2006）</span>-->
<!--            </div>-->
        </div>
      </div>
    </div>
</template>

<script>

    export default {
        name: 'EvaluationThird',
        data() {
            return {
                tableData: [{
                    standard: 'A级',
                    definition: '结构承载⼒能满⾜正常使⽤要求，⽆危险点，房屋结构安全。',
                    accord:'《危险房屋鉴定标准》（JGJ125-2016）'
                }, {
                    standard: 'B级',
                    definition: '结构承载⼒基本能满⾜正常使⽤要求，个别结构构件处于危险状态，但不影响主体结构，基本满⾜正常使⽤要求。',
                    accord:'《危险房屋鉴定标准》（JGJ125-2016）'
                }, {
                    standard: 'C级',
                    definition: '部分承重结构承载⼒不能满⾜正常使⽤要求，局部出现险情，构成局部危房，⼀般需要加固或局部改造。',
                    accord:'《危险房屋鉴定标准》（JGJ125-2016）'
                }, {
                    standard: 'D级',
                    definition: '承重结构承载⼒已不能满⾜正常使⽤要求，房屋整体出现险情，构成整幢危房，⼀般应整体拆除。',
                    accord:'《危险房屋鉴定标准》（JGJ125-2016）'
                }],
                loading: false,
            };
        },
        mounted:function(){

        },
        methods:{
            downloadLeft(){
                this.loading = true;
                const req =  '煤炭工业露天矿边坡工程监测规范-GB 51214-2017'
                this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
                    if(!res){
                        this.loading = false;
                        return
                    }
                    if(res.data.status==404){
                        this.loading = false;
                        return
                    }
                    const _res = res.data;
                    if(_res.type == 'application/octet-stream'){
                        this.loading = false;
                    }
                    let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = `煤炭工业露天矿边坡工程监测规范(GB 51214-2017).pdf`;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    setTimeout(()=>{this.loading = false;},1500)

                })
            },
            downloadRight(){
                this.loading = true;
                const req ='滑坡防治工程勘查规范-DZT0218-2006'
                this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
                    if(!res){
                        this.loading = false;
                        return
                    }
                    if(res.data.status==404){
                        this.loading = false;
                        return
                    }
                    const _res = res.data;
                    if(_res.type == 'application/octet-stream'){
                        this.loading = false;
                    }
                    let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = `滑坡防治工程勘查规范(DZT0218-2006).pdf`;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    setTimeout(()=>{this.loading = false;},1500)

                })
            }
        }
    }
</script>

<style>

    #EvaluationThird .el-table{
        color: #A7CCF6;
    }

    #EvaluationThird .el-table__row {
        background-color: #0B3A68 !important;
    }

    #EvaluationThird .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #EvaluationThird .el-table td{
        border: unset;
    }

    #EvaluationThird .el-table th.is-leaf{
        border-bottom: none;
    }

</style>

<style scoped>
    @import url('../../assets/css/style.css');
</style>



// WEBPACK FOOTER //
// src/components/evaluation/EvaluationFourth.vue